import theme from './theme';
import { breakpointsVariants, mqMax, mqMin, BREAKPOINT } from './breakpoints';
import { bezierVariants } from './beziers';
import { colorVariants } from '../utils';
import { componentVariants } from './components';
import { fontSizeVariants } from './font-sizes';
import { typographyVariants } from './typography';
import { radiiVariants } from './radii';
import { shadowsVariants } from './shadows';
import { spaceVariants } from './space';
import { zIndicesVariants } from './z-indices';

// variant keys
export const variants = {
  ...componentVariants,
  beziers: bezierVariants,
  breakpoints: breakpointsVariants,
  colors: colorVariants,
  fontSize: fontSizeVariants,
  typography: typographyVariants,
  radii: radiiVariants,
  shadows: shadowsVariants,
  sapce: spaceVariants,
  zIndices: zIndicesVariants,
};

// theme specifics
export { mqMin, mqMax, BREAKPOINT };
export { theme };

export default theme;
